import * as React from "react";
import {Checkbox, Tooltip} from "@vebox/etui-core";
import {Display} from "../Display";

import "./vebox-selection-list.scss";
import {generic_value} from "../../types/veboxModels";


export enum VeboxSelectionListActionType { ADD, REMOVE, UPDATE}

export enum VeboxSelectionListOptionCheckboxPosition { START, END}

export interface VeboxSelectionListAction {
    actionType: VeboxSelectionListActionType;
    value: generic_value;
}

interface VeboxSelectionListContextType {
    values: generic_value[];
    onUpdateValues: (action: VeboxSelectionListAction) => void;
    checkboxPosition?: VeboxSelectionListOptionCheckboxPosition;
    disable?: boolean;
}

const VeboxSelectionListContext = React.createContext<VeboxSelectionListContextType>({} as any);

export interface VeboxSelectionListProps {
    values?: generic_value[];
    onChange?: (values: generic_value[]) => void;
    checkboxPosition?: VeboxSelectionListOptionCheckboxPosition;
    disable?: boolean;
}

interface VeboxOptionListProps extends React.LiHTMLAttributes<any> {
    disable?: boolean
    disabledMessage?: string
}


export class VeboxSelectionList extends React.Component<VeboxSelectionListProps & React.HTMLAttributes<any>> {

    public static Option: React.FC<VeboxOptionListProps> = (props) => {

        const veboxSelectionListContext = React.useContext(VeboxSelectionListContext);

        const isChecked = veboxSelectionListContext.values.findIndex(v => v === props.value) > -1;

        const toggleCheck = () => {
            veboxSelectionListContext.onUpdateValues({
                value: props.value,
                actionType: isChecked ? VeboxSelectionListActionType.REMOVE : VeboxSelectionListActionType.ADD,
            });
        };

        const positioningClass = veboxSelectionListContext.checkboxPosition !== VeboxSelectionListOptionCheckboxPosition.END
            ? "checkbox-position-start"
            : "checkbox-position-end";

        return (
            <li {...props} className={"vebox-selection-list-option " + positioningClass + " " + (props.className ?? "") + ((props.disable && !veboxSelectionListContext.disable) ? " vebox-selection-list-disable " : "")}>
                <Display isVisible={veboxSelectionListContext.checkboxPosition !== VeboxSelectionListOptionCheckboxPosition.END}>
                    <div className={"vebox-selection-list-option-checkbox-wrapper"}>
                        <Tooltip
                            message={props?.disabledMessage}
                            disableToolTip={!(veboxSelectionListContext.disable || props.disable)}
                            placement={"right"}
                        >
                            <Checkbox
                                className={"vebox-selection-list-option-checkbox"}
                                checked={isChecked}
                                onChange={toggleCheck}
                                disabled={veboxSelectionListContext.disable || props.disable}
                            />
                        </Tooltip>
                    </div>
                </Display>
                <div className={"vebox-selection-list-option-body"}>
                    {props.children}
                </div>
                <Display isVisible={veboxSelectionListContext.checkboxPosition === VeboxSelectionListOptionCheckboxPosition.END}>
                    <div className={"vebox-selection-list-option-checkbox-wrapper"}>
                        <Checkbox
                            className={"vebox-selection-list-option-checkbox"}
                            checked={isChecked}
                            onChange={toggleCheck}
                        />
                    </div>
                </Display>
            </li>
        );
    }

    public render() {
        return (
            <ul
                {...this.props}
                className={"vebox-selection-list " + (this.props.disable ? "vebox-selection-list-disable " : "") + (this.props.className ?? "")}
                onChange={undefined}
            >
                <VeboxSelectionListContext.Provider
                    value={{
                        values: this.props.values ?? [],
                        onUpdateValues: this.updateValues,
                        checkboxPosition: this.props.checkboxPosition,
                        disable: this.props.disable
                    }}
                >
                    {this.props.children}
                </VeboxSelectionListContext.Provider>
            </ul>
        );
    }

    private updateValues = (action: VeboxSelectionListAction) => {
        if (!this.props.onChange) {
            return;
        }
        switch (action.actionType) {
            case VeboxSelectionListActionType.ADD: {
                this.props.onChange([...(this.props.values ?? []), action.value]);
                break;
            }
            case VeboxSelectionListActionType.REMOVE: {
                this.props.onChange((this.props.values ?? []).filter(v => v !== action.value));
                break;
            }
        }
    }
}